import styled from "styled-components";

export const DBDriveSection = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;
